















import { DiscordUserInterface } from "@/types";
import Discord from "@/Discord";
import User from "@/User";
import Vue from "vue";
import Component from "vue-class-component";
import { PropSync } from "vue-property-decorator";

@Component
export default class UserAvatar extends Vue {
  @PropSync("user", { required: true }) public userProp!: DiscordUserInterface;
  @PropSync("showName", { default: true }) public showNameProp!: boolean;
  @PropSync("size", { default: 40 }) public sizeProp!: number;

  // Merges API-provided user data with locally cached icon for the logged-in user,
  // since slot/reserve endpoints don't return selectedIcon.
  public get enrichedUser(): DiscordUserInterface {
    const local = User.get();
    if (local && String(this.userProp.id) === String(local.id) && !this.userProp.selectedIcon && local.selectedIcon) {
      return Object.assign({}, this.userProp, { selectedIcon: local.selectedIcon });
    }
    return this.userProp;
  }

  public get hasAvatar(): boolean {
    return !!(this.enrichedUser && this.enrichedUser.avatar && this.enrichedUser.avatar !== "null");
  }

  public get displayName(): string {
    return this.enrichedUser.globalName || this.enrichedUser.username;
  }

  public get discordAvatarUri(): string {
    return Discord.avatarSourceUri(this.enrichedUser.id, this.enrichedUser.avatar);
  }

  public get iconUrl(): string | null {
    const icon = this.enrichedUser.selectedIcon;
    if (!icon) { return null; }
    try {
      return require(`@/assets/images/icons/${icon.filename}.svg`);
    } catch {
      return null;
    }
  }

  public get badgeSize(): number {
    return Math.max(14, Math.round(this.sizeProp * 0.44));
  }

  public get badgeStyle(): object {
    return { width: `${this.badgeSize}px`, height: `${this.badgeSize}px` };
  }

  public formatFilename(filename: string): string {
    return filename
      .replace(/^rank_/, "")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  }
}
